import map from 'lodash/map';
import every from 'lodash/every';
import zipObject from 'lodash/zipObject';
import { createAsyncThunk } from '@reduxjs/toolkit';

// api
import finishedGoodTemplatesApi from '../../../api/finishedGoodTemplateApi';
import factoryOptionsApi from '../../../api/factoryOptionsApi';
import productBrandsApi from '../../../api/productBrandsApi';

// ---------------------------------------------------------------------

const REDUCER_NAME = 'finishedGoodTemplate';

export const GetFinishedGoodTemplates = createAsyncThunk(
  `${REDUCER_NAME}/getFinishedGoodTemplate`,
  async (__, thunkAPI) => {
    const res = await finishedGoodTemplatesApi.getV2();

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const GetFinishedGoodTemplateById = createAsyncThunk<any, string>(
  `${REDUCER_NAME}/getFinishedGoodTemplateById`,
  async (id, thunkAPI) => {
    const res = await finishedGoodTemplatesApi.getById(id);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const UpdateFinishedGoodTemplate = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/updateFinishedGoodTemplate`,
  async ({ id, data }, thunkAPI) => {
    const res = await finishedGoodTemplatesApi.update(id, data);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const CreateFactoryOption = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/createFactoryOption`,
  async (data, thunkAPI) => {
    const res = await factoryOptionsApi.create(data);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const GetFinishedGoodTemplatesFactoryOptions = createAsyncThunk(
  `${REDUCER_NAME}/getFinishedGoodTemplatesFactoryOptions`,
  async (__, thunkAPI) => {
    const optionNames = ['finishedGoodTypes'];

    const optionResponses = await Promise.all(map(optionNames, (name) => factoryOptionsApi.getByName(name)));

    const allResponsesSuccessful = every(optionResponses, (res) => res.status === 200);

    if (allResponsesSuccessful) {
      const data = map(optionResponses, 'data');
      return zipObject(optionNames, data);
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const GetFinishedGoodTemplatesProductBrands = createAsyncThunk(
  `${REDUCER_NAME}/getFinishedGoodTemplatesProductBrands`,
  async (__, thunkAPI) => {
    const res = await productBrandsApi.get();

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const CreateProductBrand = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/createProductBrand`,
  async (data, thunkAPI) => {
    const res = await productBrandsApi.create(data);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);
